// @ts-nocheck

export const MPRegisterAPIErrorCodes = {
  E_ALREADY_REGISTERED: 48013,
  E_RMJ_30: 48014,
  E_USER_EXCLUDED: 48010,
};
